import React, { useEffect } from 'react'
import { useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Form, Schema, TagPicker } from 'rsuite';
import peApplicationService from '../../../../../../services/Public/Application/PE/peApplication.service'
import residencyService from '../../../../../../services/Public/Application/PE/residency.service'
import { getStates } from '../../../../../../services/Shared/codeTable.service'
import Information from '../../../../../Shared/Card/Information'
import Issues from '../../../../../Shared/Card/Issues'
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons'
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner'
import { GetAppInformationContent } from '../../../../../Shared/InformationContent/PeInformation'
import { AccessibleTagPicker } from '../../../../../Shared/GenericComponents/AccessibleComponents'

function ResidencyPage() {
    const entityId = useSelector(x => x.userInfo.EntityId)
    const appId = useSelector(x => x.currentApplicationId);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const appType = appTypeId == 3 ? "By Comity" : appTypeId == 4 ? "By Exam" : "";
    const [model, setModel] = useState({
        applicationId: appId,
        entityId: entityId,
        states: []
    })
    const [hasLoaded, setHasLoaded] = useState(true)
    const push = useNavigate();
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 17;
    const [states, setStates] = useState([])
    const [sectionData, setSectionData] = useState({})
    useEffect(() => {
        peApplicationService.peGetSection(appId, sectionId).then((response) => {
            getStates().then(setStates);
            setSectionData(response.data);
            residencyService.getResidency(appId).then((data) => {
                if (data.data)
                    setModel(data.data)
                setHasLoaded(true);
            })
        })
    }, [])

    const { ArrayType } = Schema.Types;
    const validationModel = Schema.Model({
        states: ArrayType().isRequired('This field is required.')
    })
    const formSubmit = () => {
        residencyService.postResidency(model).then((response) => {
            nextSectionNavigation();
        })
    }

    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <Container fluid>
            <b>Professional Engineer Application {appType}</b>
            <h4 className="mb-3">Residency</h4>
            <Information content={GetAppInformationContent("residency")} />
            <br />{hasLoaded ?
                <Form readOnly={!sectionData.isUserEditable} model={validationModel} onChange={setModel} formValue={model} onSubmit={formSubmit}>
                    <Card className="mb-3">
                        <Card.Header>
                            <h6>Residency</h6>
                        </Card.Header>
                        <Card.Body>
                            <Form.Group>
                                <Form.ControlLabel>
                                    <b>What state(s) do you currently hold an active license in? Select all choices below that are applicable.</b>
                                </Form.ControlLabel>
                                <Form.Control
                                    accepter={AccessibleTagPicker}
                                    ariaLabel="Select active license states"
                                    placeholder="Select a State"
                                    block
                                    data={states}
                                    searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                                    name="states" />
                                <Form.HelpText className="d-none">States with active license</Form.HelpText>
                            </Form.Group>
                        </Card.Body>
                    </Card>
                    <Issues isUserEditable={true} type={1} sectionId={sectionData.id} />
                    <FormActionButtons isReadOnly={!sectionData.isUserEditable} nextSectionCallback={nextSectionNavigation} backToSectionLink="/individual/peapp/sections" />
                </Form> : <LoadingSpinner />}
        </Container>
    );
}
export default ResidencyPage;